import { render } from "./adsTest.vue?vue&type=template&id=fbdc3cac&scoped=true"
import script from "./adsTest.vue?vue&type=script&lang=js"
export * from "./adsTest.vue?vue&type=script&lang=js"

import "./adsTest.vue?vue&type=style&index=0&id=fbdc3cac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdc3cac"]])

export default __exports__